import React, { useState } from 'react';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { NavLink } from 'react-router-dom';

import './Footer.css';

import xIcon from './assets/images/x-logo-icon.svg';
import instaIcon from './assets/images/instagram-logo-icon.svg';
import youTubeIcon from './assets/images/youTube-logo-icon.svg';
import linkedinIcon from './assets/images/linkedIn-logo-icon.svg';


function Footer() {

  return (
    <footer className="footer container-fluid">
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
            <div className='helper-section'>
                <h3 className='helper-title display-6'>We’re here to help</h3>
                <p className='helper-text'>Ask the tough questions. We’re ready for them.</p>
                <button className='btn btn-secondary btn-lg px-4 rounded-pill mt-2'>Contact an expert</button>
              </div>
              </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-6 col-sm-12">
            <div className='d-flex flex-column'>
              <ul className='social-media d-flex flex-row m-0 list-none'>
                  <li>
                    <a href="#">
                    <img src={xIcon} alt='x-icon' className='img-fluid' /></a>
                  </li>

                  <li>
                    <a href="#">
                    <img src={instaIcon} alt='x-icon' className='img-fluid' /></a>
                  </li>

                  <li>
                    <a href="#">
                    <img src={youTubeIcon} alt='x-icon' className='img-fluid' /></a>
                  </li>

                  <li>
                    <a href="#">
                    <img src={linkedinIcon} alt='x-icon' className='img-fluid' /></a>
                  </li>
                  
                </ul>
                
              <p className='copyright-text mt-4'>Copyright &copy; 2025 Elevate, Inc. All Rights Reserved</p>
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className='d-flex footer-links-container'>
            <ul className="footer-links d-flex fex-row list-none">
              <li>
                <NavLink className="nav-link" to="/about-us">
                  About Us
                </NavLink>
              </li>
              <li>
              <NavLink className="nav-link" to="/services">
                  Services
                </NavLink>
              </li>
              <li>
                <NavLink className="nav-link" to="/solutions">
                  Solutions
                </NavLink></li>
              <li>
              <NavLink className="nav-link" to="/resources">
                  Resources
                </NavLink>
              </li>
              <li>
              <NavLink className="nav-link" to="/contact-us">
                  Contact Us
                </NavLink>
              </li>
            </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
    
  );
}

export default Footer;
